import { NavLink } from 'react-router-dom';
import { purchaseRequestService } from 'services/api';
import { useTranslation } from 'react-i18next';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import TenantPage from 'components/common/TenantPage';
import { ButtonGroup, Button } from '@mui/material';
import { useRef, useState, useEffect } from 'react';
import toast from 'features/toast';
import { PurgeButton } from 'components/helpers/PurgeButton';
import { PurchaseLineColumns } from 'components/common/enhanced/common-headers/purchase-request';
import { GridColDef } from '@mui/x-data-grid-premium';
import { isTechnician } from 'components/helpers/IsTechnician';
import { isTechnicianCoordinator } from 'components/helpers/IsTechnicianCoordinator';
import {
  IsTenantAdministrator,
  isTenantAdministrator
} from 'components/helpers/IsTenantAdministrator';

export const PurchaseRequestList = () => {
  const translationPrefix = 'pages.purchase-requests.list';
  const [numPurchaseAutomatic, setNumPurchaseAutomatic] = useState(0);

  const canCreate = isTechnicianCoordinator() || isTenantAdministrator() || isTechnician();

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const handleDelete = (id: number) => {
    purchaseRequestService.delete(id).then(() => {
      toast.success(t('actions.successfully.deleted'));
      datagridRefresh.current();
    });
  };

  const columns: GridColDef[] = PurchaseLineColumns(
    t(`${translationPrefix}.delete-confirmation-extended`),
    handleDelete
  );

  useEffect(() => {
    purchaseRequestService
      .getAllPaginated(0, 0, { automatic_generated: true, status: 'NEW' })
      .then((res) => {
        setNumPurchaseAutomatic(res.count);
      });
  }, []);

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <div>
            <ButtonGroup>
              {canCreate && (
                <NavLink to="new">
                  <Button variant="outlined" color="primary" size="small">
                    {t(`${translationPrefix}.add-new`)}
                  </Button>
                </NavLink>
              )}
              <IsTenantAdministrator>
                <NavLink to="automatic">
                  <Button size="small" color={numPurchaseAutomatic > 0 ? 'error' : 'success'}>
                    <>
                      {t(`${translationPrefix}.automatic`)} ({numPurchaseAutomatic})
                    </>
                  </Button>
                </NavLink>
              </IsTenantAdministrator>
              <PurgeButton service={purchaseRequestService} refresh={datagridRefresh} />
            </ButtonGroup>
          </div>
        }>
        <EnhancedDataGrid
          columns={columns}
          service={purchaseRequestService}
          refresh={datagridRefresh}
          disableDelete
        />
      </TenantPage>
    </>
  );
};

export default PurchaseRequestList;
